import SortIcon from '../../../../Assets/icons/sort.svg'
import Search from './Search/Search'

import OrganizationCard from '../../../Partials/Layouts/OrganizationCard/OrganizationCard'
import { useSelector } from 'react-redux'


function OrganizationList({
    selectedSubcategory, searchOrgs, triggerFetch, handleFilterShow, searchQuery, setSearchQuery
}) {

    const { consumer } = useSelector(state => state.auth)

    return (
        <div className="col right">
            <div className="orgs_page_header">
                <div>
                    {
                        consumer
                            ?
                            consumer.language === 'english'
                                ?
                                <>
                                    <h1>{selectedSubcategory ? selectedSubcategory.engName : ''}</h1>
                                    <p>Showing {searchOrgs ? searchOrgs.length : ''} {selectedSubcategory ? selectedSubcategory.engName : ''}</p>
                                </>
                                :
                                <>
                                    <h1>{selectedSubcategory ? selectedSubcategory.name : ''}</h1>
                                    <p>{searchOrgs ? searchOrgs.length : ''}টি {selectedSubcategory ? selectedSubcategory.name : ''} দেখাচ্ছে</p>
                                </>
                            :
                            <>
                                <h1>{selectedSubcategory ? selectedSubcategory.name : ''}</h1>
                                <p>{searchOrgs ? searchOrgs.length : ''}টি {selectedSubcategory ? selectedSubcategory.name : ''} দেখাচ্ছে</p>
                            </>
                    }

                </div>
                <div>
                    <Search
                        selectedSubcategory={selectedSubcategory}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        consumer={consumer}
                    />
                </div>
                <button type='button' onClick={handleFilterShow}>
                    <img src={SortIcon} alt="icon" />
                    ফিল্টার
                </button>
            </div>
            <div className="row organizations_cards">
                {searchOrgs?.map(organization => (

                    <OrganizationCard
                        key={organization._id}
                        organization={organization}
                        triggerFetch={triggerFetch}
                    />
                ))}

                {/* {loading ? '...loading' : ''} */}
            </div>
        </div>
    )
}

export default OrganizationList